import {push} from 'react-router-redux';
import jwtDecode from 'jwt-decode';
import Config from '../config';
import axios from "axios/index";
import {notification} from '../helpers';

/**
 * Login
 */
export function login(email, password) {
    return (dispatch) => {

        dispatch({
            type: 'USER_LOGIN_SUBMITTING'
        });

        return fetch(Config.api.getDomain() + 'user/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userName: email,
                password: password
            })
        }).then(response => {
            let json = response.json();

            if (response.ok) {
                json.then(function (result) {
                    localStorage.setItem('apitoken', result.token);
                    localStorage.setItem('role', jwtDecode(result.token).Role);
                });

                return json;
            } else {
                return json.then(Promise.reject.bind(Promise));
            }
        }).then(response => {
            dispatch({
                type: 'USER_LOGIN_IN'
            });

            return response;
        }).catch(error => {
            dispatch({
                type: 'USER_LOGIN_FAILED'
            });
            return error;
        });
    }
}

/**
 * Logout
 */
export function logout() {
    return (dispatch) => {
        Config.api.clearStorage();
        dispatch({
            type: 'USER_LOG_OUT'
        });
        dispatch({
            type: 'CARS_RESET',
            payload: true
        });
        dispatch({
            type: 'IMPORT_RESET',
            payload: true
        });
        dispatch({
            type: 'REFRESH_RESET',
            payload: true
        });
        dispatch({
            type: 'REPORTS_RESET',
            payload: true
        });
        dispatch({
            type: 'SIDEBAR_RESET',
            payload: true
        });
        dispatch({
            type: 'STATIONS_RESET',
            payload: true
        });
        dispatch({
            type: 'USERS_RESET',
            payload: true
        });
        dispatch({
            type: 'WHEELCHANGERS_RESET',
            payload: true
        });
        dispatch({
            type: 'WHEELS_RESET',
            payload: true
        });

        dispatch(push('/login'));
    }
}

export function fieldChange() {
    return (dispatch) => {
        dispatch({
            type: 'USER_LOGIN_RESET_ATTEMPT'
        });
    }
}

export function destroy(id) {
    if (Number.isInteger(parseInt(id, 10))) {
        return (dispatch) => {
            return axios.delete(Config.api.getDomain() + 'admin/deleteuser/' + id, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'USER_DESTROY_SUCCESS',
                    payload: response
                });
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                notification("Användaren raderades framgångsrikt!");
                return Promise.resolve(true);
            }).catch(error => {
                dispatch({
                    type: 'USER_DESTROY_FAILURE',
                    payload: error
                });
                notification("Användaren raderade misslyckades!");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'USER_DESTROY_FAILURE',
                palyload: {"message": "No user id passed"}
            });
        };
    }
}


export function restore(id) {

    if (Number.isInteger(parseInt(id, 10))) {

        return (dispatch) => {
            return axios.put(Config.api.getDomain() + 'user/put', {
                "id": id,
                active: true
            }, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'USER_RESTORE_SUCCESS',
                    payload: response
                });
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                notification("Användarens återställning lyckades!");
                return Promise.resolve(true);
            }).catch(error => {
                dispatch({
                    type: 'USER_RESTORE_FAILURE',
                    payload: error
                });
                notification("Användaråterställning misslyckades!");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'USER_RESTORE_FAILURE',
                palyload: {"message": "No user id passed!"}
            });
            notification("Användaråterställning misslyckades!");
        };
    }
}


export function put(data) {

    if (Number.isInteger(parseInt(data.id, 10))) {
        return (dispatch) => {
            dispatch({
                type: 'USER_UPDATE_INPROGRESS',
                payload: data
            });
            return axios.put(Config.api.getDomain() + 'user/put', data, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'USER_UPDATE_SUCCESS',
                    payload: response
                });
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                notification("Användaren har ändrats!");
                return Promise.resolve(true);
            }).catch(error => {

                dispatch({
                    type: 'USER_UPDATE_FAILURE',
                    payload: error
                });
                notification("Användaren ändrats inte!");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'USER_UPDATE_FAILURE',
                payload: {"message": "No user id"}
            });
            notification("Användardata sparades inte!");
        };
    }
}


export function post(data) {

    return (dispatch) => {
        dispatch({
            type: 'USER_CREATE_INPROGRESS',
            payload: data
        });
        return axios.post(Config.api.getDomain() + 'user/Create', data, Config.api.getConfig())
            .then(response => {
                notification('Användare skapad')
                dispatch({
                    type: 'USER_CREATE_SUCCESS',
                    payload: data
                });
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
            })
            .catch(error => {
                let message = error.response.data.message;
                notification('Användare inte skapas: ' + message)
                dispatch({
                    type: 'USER_CREATE_FAILURE',
                    payload: error
                });
            })
    }

}


export function assimilate(userId){

    return (dispatch) => {
        //loading thing next to user
        dispatch({
            type: 'USER_UPDATE_INPROGRESS',
            payload: {id:userId}
        });

        return axios.post(Config.api.getDomain() + 'user/assimilate/'+userId, {userId:userId}, Config.api.getConfig())
            .then(response => {
                notification('Användaren assimileras.')

                localStorage.setItem('apitoken_original', localStorage.getItem('apitoken'));
                localStorage.setItem('apitoken', response.data.token);
                localStorage.setItem('role', jwtDecode(response.data.token).Role);

                dispatch({
                    type: 'USER_ASSIMILATE_SUCCESS',
                    payload: response.data
                });



                dispatch({
                    type: 'CARS_RESET',
                    payload: true
                });
                dispatch({
                    type: 'IMPORT_RESET',
                    payload: true
                });
                dispatch({
                    type: 'REFRESH_RESET',
                    payload: true
                });
                dispatch({
                    type: 'REPORTS_RESET',
                    payload: true
                });
                dispatch({
                    type: 'SIDEBAR_RESET',
                    payload: true
                });
                dispatch({
                    type: 'STATIONS_RESET',
                    payload: true
                });
                dispatch({
                    type: 'USERS_RESET',
                    payload: true
                });
                dispatch({
                    type: 'WHEELCHANGERS_RESET',
                    payload: true
                });
                dispatch({
                    type: 'WHEELS_RESET',
                    payload: true
                });

                //window.location.href = '/'
                dispatch(push('/'));
            })
            .catch(error => {
                console.log(error);
                //let message = error.data.message;
                //notification('Något gick fel: ' + message)
                dispatch({
                    type: 'USER_ASSIMILATE_FAILURE',
                    payload: error
                });
            })

    }

}




// WEBPACK FOOTER //
// ./src/actions/users.js